import React from 'react'
import { useTranslation } from 'react-i18next'

import { CardContent } from 'js/components/Card/Card'
import FeedItem from 'js/components/FeedItem/FeedItem'
import { H3 } from 'js/components/Heading'
import Text from 'js/components/Text/Text'

import ExternalIcon from 'icons/new-window-small.svg'

interface Props {
    result: {
        id: string
        title: string
        snippet: string
        url: string
    }
    'data-feed': number
}

const ExternalSearchResult = ({ result, 'data-feed': dataFeed }: Props) => {
    const { t } = useTranslation()

    const { title, snippet, url } = result

    return (
        <FeedItem data-feed={dataFeed}>
            <CardContent className="FeedItemContent">
                {title && (
                    <H3 className="FeedItemTitle">
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`${title}${t(
                                'global.opens-in-new-window',
                            )}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                            }}
                        >
                            {title}
                            <ExternalIcon />
                        </a>
                    </H3>
                )}

                {snippet && (
                    <div className="FeedItemExcerpt">
                        <Text>{snippet}</Text>
                    </div>
                )}
            </CardContent>
        </FeedItem>
    )
}

export default ExternalSearchResult
